/**
 * Component property editor section.
 */
export enum Section {
  Main = 'main',
  Style = 'style',
  Actions = 'actions',
  Rules = 'rules',
}

/**
 * Component property editor subsection.
 */
export enum SubSection {
  Additional = 'additional',
  Tooltip = 'tooltip'
}
